import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useCarouselHeaderStyles = makeStyles({
    headerContainer: {
        display: 'flex',
        height: '32px',
        justifyContent: 'space-between',
        lineHeight: tokens.lineHeightBase600,
        userSelect: 'none',
        ':disabled': {
            color: tokens.colorNeutralForegroundDisabled,
        },
    },
    extraHeaderContainer: {
        marginBottom: '12px',
    },
    extraCompositeHeaderContainer: {
        marginBottom: '4px',
    },
    pageTitle: {
        fontSize: tokens.fontSizeBase500, // 20px
    },
    subTitleTwo: {
        fontSize: tokens.fontSizeBase400, // Subtitle 2 - 16px
    },
    titleBase: {
        color: tokens.colorNeutralForeground1,
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightSemibold,
    },
    compositeTitleBase: __assign(__assign({ display: 'flex', flexDirection: 'row', minWidth: 0 }, shorthands.gap('6px')), shorthands.margin('6px', '4px', '0px', '4px')),
    text: __assign(__assign({}, shorthands.overflow('hidden')), { textOverflow: 'ellipsis', color: tokens.colorNeutralForeground1, fontWeight: tokens.fontWeightSemibold, whiteSpace: 'nowrap' }),
    iconThumbnail: {
        height: '20px',
    },
});
//# sourceMappingURL=CarouselHeader.styles.js.map